var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "115px",
    height: "83px",
    viewBox: "0 0 115 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "063081E0-229F-48D1-9721-F2594DA04371") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Profile-&-Settings-\\uD83D\\uDC81\\uD83C\\uDFFB\\u200D\\u2640\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Update-Email-4",
    transform: "translate(-131.000000, -196.000000)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Page/Email",
    transform: "translate(73.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    transform: "translate(58.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.393616,0 L11.9621785,0 C5.35876508,0.00752213306 0.00751504788,5.36381732 0,11.9734564 L0,71.0265436 C0.00751504788,77.6361827 5.35876508,82.9924779 11.9621785,83 L102.393377,83 C108.99679,82.9924779 114.348041,77.6361827 114.355556,71.0265436 L114.355556,11.9734564 C114.348304,5.36380142 108.997045,0.0073906984 102.393616,0 Z M81.1248629,41.4837161 L109.570923,19.1369359 L109.570923,69.1232429 L81.1248629,41.4837161 Z M11.9621785,4.78938257 L102.393377,4.78938257 C106.355436,4.79386952 109.566201,8.00766204 109.570684,11.9734564 L109.570684,13.0486728 L63.5378288,49.2128217 C60.0746523,51.919013 55.2148199,51.9150619 51.75604,49.2032429 L4.7848714,13.039573 L4.7848714,11.9734564 C4.78935412,8.00766204 8.00011953,4.79386952 11.9621785,4.78938257 Z M34.0773756,41.6341027 L4.7848714,69.219749 L4.7848714,19.081858 L34.0773756,41.6341027 Z M102.393616,78.2106174 L11.9621785,78.2106174 C9.47072796,78.2091661 7.15817275,76.9148431 5.85237621,74.7909983 L37.9191489,44.5939411 L48.8243493,52.9897288 C54.0137877,57.0470894 61.2970016,57.0452129 66.4843527,52.9851789 L77.326632,44.4694172 L108.51562,74.7718407 C107.212078,76.9065911 104.893176,78.2091363 102.393616,78.2106174 Z",
    id: "Shape",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2c9b4f5efaa756ca2734972bda3d64f9.svg";
export { ForwardRef as ReactComponent };